<template>
  <mc-dialog
    ref="unsavedChangesDialog"
    class="unsaved-changes-dialog"
    submit-button-text="Discard Changes"
    submit-button-class="error-primary-button"
    cancel-button-text="Keep Editing"
    cancel-button-class="neutral-soft-button"
    @submit="onDiscardChanges"
    @cancel="onContinueEditing"
  >
    <template #header>
      <section class="title-wrapper">
        <span class="icon-circle-exclamation"></span>
        <h3 class="title-dialog">
          Discard Changes?
        </h3>
      </section>
    </template>

    <div class="warning-message">
      {{ warningMessage }}
    </div>

  </mc-dialog>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from "vue";
import McDialog from "@/components/ui/McDialog/McDialog.vue";
import { useUnsavedChangesStore } from "@/store/unsavedChangesStore";

const unsavedChangesStore = useUnsavedChangesStore();

const showDialog = ref(false);
const unsavedChangesDialog = ref();
const warningMessage = computed(() => unsavedChangesStore.warningMessage);

const emit = defineEmits(['discard-changes', 'continue-editing']);

const onContinueEditing = () => {
  unsavedChangesStore.handleDialogActions(true);
  showDialog.value = false;
};

const onDiscardChanges = () => {
  unsavedChangesStore.handleDialogActions(false);
  showDialog.value = false;
};

onMounted(() => {
  unsavedChangesStore.$onAction(({ name })=> {
    if (name === "showUnsavedChangesDialog") {
      showDialog.value = true;
    }
  });
});

watch(showDialog, (newValue) => {
  newValue ? unsavedChangesDialog.value.openDialog() : unsavedChangesDialog.value.closeDialog();
});
</script>

<style scoped lang="scss">
.unsaved-changes-dialog {
  --dialog-width: 475px;
  --dialog-submit-button-width: 140px;
  --dialog-cancel-button-width: 120px;
  --dialog-action-buttons-padding: 0 12px;
  --dialog-actions-section-margin: 32px 0 0 0;

  .title-wrapper {
    display: flex;
    align-items: center;
    gap: 18px;

    .icon-circle-exclamation {
      color: var(--colour-text-danger-subtle);
      font-size: 32px;
    }
  }

  .warning-message {
    margin-top: 16px;
    color: var(--colour-text-neutral-subtle);
    font-size: var(--font-size-body-regular);
    font-style: normal;
    font-weight: var(--font-weight-body-regular);
    line-height: var(--line-height-m);
  }
}
</style>